export default function subStr(string, character, position) {
    if(position=='b')
    return string.substring(string.indexOf(character) + 1);
    else if(position=='a')
    return string.substring(0, string.indexOf(character));
    else
    return string;
 }